import React, { useState } from 'react';
import './UserAvatar.css';

interface UserAvatarProps {
  user: {
    id: number;
    first_name?: string;
    last_name?: string;
    username?: string;
    avatar?: string | null;
  };
  size?: 'small' | 'medium' | 'nav' | 'large';
  className?: string;
  onClick?: () => void;
}

const UserAvatar: React.FC<UserAvatarProps> = ({ user, size = 'medium', className = '', onClick }) => {
  const getInitials = () => {
    const firstName = user.first_name || '';
    const lastName = user.last_name || '';
    const username = user.username || '';
    
    if (firstName && lastName) {
      return (firstName.charAt(0) + lastName.charAt(0)).toUpperCase();
    } else if (firstName) {
      return firstName.charAt(0).toUpperCase();
    } else if (username) {
      return username.charAt(0).toUpperCase();
    }
    return '?';
  };

  const getAvatarColor = (userId: number) => {
    const colors = ['#667eea', '#764ba2', '#f093fb', '#4facfe', '#43e97b', '#fa709a'];
    return colors[userId % colors.length];
  };

  const getAvatarUrl = () => {
    if (!user.avatar) return null;
    // Если avatar уже полный URL, возвращаем как есть
    if (user.avatar.startsWith('http')) {
      return user.avatar;
    }
    // Если путь уже начинается с /api/v1/uploads/avatars/, используем как есть
    if (user.avatar.startsWith('/api/v1/uploads/avatars/')) {
      return user.avatar;
    }
    // Иначе добавляем путь к статическим файлам
    // Если путь начинается с /, используем как есть, иначе добавляем префикс
    if (user.avatar.startsWith('/')) {
      return user.avatar;
    }
    // Если это просто имя файла, добавляем полный путь
    return `/api/v1/uploads/avatars/${user.avatar}`;
  };

  const avatarUrl = getAvatarUrl();
  const initials = getInitials();
  const backgroundColor = getAvatarColor(user.id);

  const [imageError, setImageError] = useState(false);

  const handleImageError = () => {
    setImageError(true);
  };

  return (
    <div
      className={`user-avatar user-avatar-${size} ${onClick ? 'user-avatar-clickable' : ''} ${className}`}
      style={{ backgroundColor }}
      onClick={onClick}
      title={`${user.first_name || ''} ${user.last_name || ''}`.trim() || user.username || 'User'}
    >
      {avatarUrl && !imageError ? (
        <img 
          src={avatarUrl} 
          alt={initials} 
          className="user-avatar-image" 
          onError={handleImageError}
        />
      ) : (
        <span className="user-avatar-initials">{initials}</span>
      )}
    </div>
  );
};

export default UserAvatar;

